import "../../../../js/molecules/fields/copyToClipboardField";
import "../../../../js/atoms/toggle/translate-contents";
import "../../../../js/utils/waitVote";

Domestika.contentTranslate.init();
